document.addEventListener("DOMContentLoaded", () => {
  const product_detail_images = document.getElementById(
    "product-detail-images"
  );
  product_detail_images.addEventListener(
    "youtube-video",
    (/** @type CustomEvent */ e) => {
      if (!e.detail || !e.detail.element) return;
      const /** @type HTMLDivElement */ element = e.detail.element;
      const /** @type HTMLDivElement */ youtube_wrapper = element.querySelector('.carousel-item-youtube')
      // console.log("youtube-video", element.dataset);
      if(!youtube_wrapper) return;
      youtube_wrapper.insertAdjacentHTML(
        "afterbegin",
        `<iframe class="w-100 h-100" width="${element.dataset.youtubeEmbedWidth}" height="${element.dataset.youtubeEmbedHeight}" src="${element.dataset.youtubeEmbed}?rel=0&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      );
    }
  );
  product_detail_images.addEventListener("stop-youtube-video", () => {
    // console.log("stop-youtube-video", e);
    product_detail_images
      .querySelectorAll("iframe")
      .forEach(function (element) {
        element.remove();
      });
  });
});
